/*************************************************/
/* NEWS                                          */
/*************************************************/

export function news($body, bodyLoadingClass, currentCulture) {
    let $newsContainer,
        $lazyLoadButton,
        $lazyLoadContainer,
        $newsListContainer,
        pageSize,
        totalSize,
        newsPageId,
        newsControllerUrl,
        filters,
        defaultFilter,
        currentFilter,
        itemsToSkip;

    const init = function () {
        $newsContainer = $(".news-section"),
            $lazyLoadButton = $newsContainer.find(".news-items__load-more"),
            $lazyLoadContainer = $lazyLoadButton.parent(".news-items__cta"),
            filters = $('input[name="newsevents-filter"]'),
            defaultFilter = $('input[name="newsevents-filter"][value="all"]'),
            currentFilter = defaultFilter.val(),
            $newsListContainer = $newsContainer.find(".news-items"),
            pageSize = $newsContainer.data("newslist-pagesize"),
            totalSize = defaultFilter.attr('data-listsize'),
            newsPageId = $newsContainer.data("newspage-id"),
            newsControllerUrl = "/umbraco/surface/newsevents/getnewseventslistpage",
            itemsToSkip = pageSize;

        filters.closest('label').removeClass('current');
        defaultFilter.prop("checked", true);
        defaultFilter.closest('label').addClass('current');

        $lazyLoadButton.click(function () {
            if (currentFilter === defaultFilter.val()) {
                loadNews(null, true);
            } else {
                loadNews(currentFilter, true);
            }
        });

        filters.change(function () {
            filters.closest('label').removeClass('current');
            currentFilter = this.value;
            totalSize = $(this).attr('data-listsize');
            $lazyLoadContainer.show();

            itemsToSkip = pageSize;
            $(this).closest('label').addClass('current');
            loadNews(this.value, false);
        });

    };

    const loadNews = function (type, incerementPagesize) {
        $body.addClass(bodyLoadingClass);
        $.get(newsControllerUrl,
            {
                newsEventsPageId: newsPageId,
                itemsToSkip: incerementPagesize ? itemsToSkip : 0,
                pageSize: pageSize,
                cultureCode: currentCulture,
                type: type
            }
        ).done(function (data) {
            if ($.trim(data)) {

                if (incerementPagesize) {
                    $(data).insertBefore($newsListContainer.find('.news-item.filler'));
                    //Add page size to items to skip count
                    itemsToSkip += pageSize;
                    //If there are no more items to fetch, remove the button
                    if (itemsToSkip >= totalSize) {
                        $lazyLoadContainer.hide();
                    }
                } else {
                    $newsListContainer.html(data);
                    $newsListContainer.append($('<div class="news-item filler"></div>'));
                }

            } else {
                console.log("Reponse was empty");
            }
        }).fail(function () {
            console.log("An error occured fetching the item page");
        }).always(function () {
            $body.removeClass(bodyLoadingClass);
        });
    }





    init();
}